import React, { PureComponent } from 'react'
import autobind from 'autobind-decorator'
import styles from './styles'

import Button from 'app/Components/Button'
import BottomBar from '../BottomBar'

export default class YesNoPanel extends PureComponent {
  pushAnswer(answer) {
    this.props.pushAnswer(answer, this.props.title, this.props.question)
  }

  @autobind nextYes() {
    let anwser = this.props.choices[0]
    this.pushAnswer(anwser)
    this.props.change(this.props.nextQuestion)
  }

  @autobind nextNo() {
    let anwser = this.props.choices[1]
    this.pushAnswer(anwser)
    this.props.change(this.props.nextQuestion)
  }

  @autobind goBack() {
    this.props.goBack()
  }

  render() {
    const { question } = this.props
    return (
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.question}>
            <label className={styles.label}> {question} </label>
          </div>
          <div className={styles.choicesDiv}>
            <div className={styles.medNonmed}>
              <Button onClick={this.nextYes}>
                Medical
              </Button>
              <Button onClick={this.nextNo}>
                Non-Medical
              </Button>
            </div>
          </div>
          <BottomBar goBack={this.goBack} hideNext />
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/Panel/YesNoPanel.js
 **/